export default __webpack_public_path__ + "static/media/history_1980_03.15007d89.png";